import React, { Fragment } from 'react';
import cx from 'classnames';

import { useCartContext } from '../CartContext';
import { CardItem } from './Card/CardItem';
import { CartItem } from './CartItem';
import { CartHeader } from './CartHeader';
import { ItemDivider } from './ItemDivider';

import styles from './cartGrid.module.less';

export const CartGrid: React.FC<{ isDgcV5: boolean; className?: string }> = ({
  children,
  isDgcV5,
  className,
}) => {
  const { items, updateCartItemQuantity, isBaby, removeCartItem } = useCartContext();
  const disableCartItemLink = isBaby;

  return (
    <div className={cx(styles.cartGrid, className)}>
      <CartHeader />
      {items.map((item, itemIndex) => {
        return (
          <Fragment key={item.id}>
            <ItemDivider
              className={cx({
                [styles.firstDivider]: itemIndex === 0,
              })}
            />
            {item.isInvite ? (
              <CardItem item={item} />
            ) : (
              <CartItem
                item={item}
                updateQuantity={updateCartItemQuantity}
                remove={removeCartItem}
                disableCartItemLink={disableCartItemLink}
                isDgcV5={isDgcV5}
              />
            )}
          </Fragment>
        );
      })}
      {children}
    </div>
  );
};
